import { Translator } from "Translator";
import { SubOption } from "model/Filters";

export enum AVAILABILITY_FILTER_OPTIONS {
  NOW = 'now',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
}

const availabilitySubOptions = [
  {
    id: 160,
    queryValue: AVAILABILITY_FILTER_OPTIONS.NOW,
    value: AVAILABILITY_FILTER_OPTIONS.NOW,
    name: Translator.translate('SearchPage.DateFilter.availabilityNow', {}, true, 'Now'),
  },
  {
    id: 161,
    queryValue: AVAILABILITY_FILTER_OPTIONS.TODAY,
    value: AVAILABILITY_FILTER_OPTIONS.TODAY,
    name: Translator.translate('SearchPage.DateFilter.availabilityToday', {}, true, 'Today'),
  },
  {
    id: 162,
    queryValue: AVAILABILITY_FILTER_OPTIONS.TOMORROW,
    value: AVAILABILITY_FILTER_OPTIONS.TOMORROW,
    name: Translator.translate('SearchPage.DateFilter.availabilityTomorrow', {}, true, 'Tomorrow'),
  },
] as SubOption[];


export default availabilitySubOptions;
